import { createSlice } from '@reduxjs/toolkit'
import { getListBar, getListPeopleCount, getListPeopleJump, getListPeopleLean, getListPintuSelatan, getListPintuUtara, getListStatistik } from '../action/summaryAction'

const initialState = {
  dataSummary: [],
  dataByIdSummary: [],
  dataPPLCNT: [],
  dataPPLLEN: [],
  dataPPLJMP: [],
  dataUtara: [],
  dataSelatan: [],
  dataStatistik: [],
  dataBar: [],
  idSummary: '',
  state: '',
  isOpenFormSummary: false,
  isLoading: false,
}
const summarySlice = createSlice({
  name: 'summary',
  initialState,
  reducers: {
    openForm: (state, action) => {
      state.isOpenFormSummary = action.payload.open
      state.state = action.payload.state
      if (action.payload.state === 'edit') {
        state.dataByIdSummary = action.payload.data
        state.idSummary = action.payload.id
      } else if (action.payload.state === 'delete') {
        state.dataByIdSummary = action.payload.data
        state.idSummary = action.payload.id
      }
    },
  },
  extraReducers: {
    [getListPeopleCount.pending]: (state) => {
      state.isLoading = true
    },
    [getListPeopleCount.fulfilled]: (state, action) => {
      // console.log(action.payload.data);
      state.dataPPLCNT = action.payload.data
      state.isLoading = false
    },
    [getListPeopleCount.rejected]: (state) => {
      state.isLoading = false
    },
    [getListPeopleJump.pending]: (state) => {
      state.isLoading = true
    },
    [getListPeopleJump.fulfilled]: (state, action) => {
      // console.log(action.payload.data);
      state.dataPPLJMP = action.payload.data
      state.isLoading = false
    },
    [getListPeopleJump.rejected]: (state) => {
      state.isLoading = false
    },
    [getListPeopleLean.pending]: (state) => {
      state.isLoading = true
    },
    [getListPeopleLean.fulfilled]: (state, action) => {
      // console.log(action.payload.data);
      state.dataPPLLEN = action.payload.data
      state.isLoading = false
    },
    [getListPeopleLean.rejected]: (state) => {
      state.isLoading = false
    },
    [getListPintuSelatan.pending]: (state) => {
      state.isLoading = true
    },
    [getListPintuSelatan.fulfilled]: (state, action) => {
      // console.log(action.payload.data);
      state.dataSelatan = action.payload.data
      state.isLoading = false
    },
    [getListPintuSelatan.rejected]: (state) => {
      state.isLoading = false
    },
    [getListPintuUtara.pending]: (state) => {
      state.isLoading = true
    },
    [getListPintuUtara.fulfilled]: (state, action) => {
      // console.log(action.payload.data);
      state.dataUtara = action.payload.data
      state.isLoading = false
    },
    [getListPintuUtara.rejected]: (state) => {
      state.isLoading = false
    },
    [getListStatistik.pending]: (state) => {
      state.isLoading = true
    },
    [getListStatistik.fulfilled]: (state, action) => {
      // console.log(action.payload.data);
      state.dataStatistik = action.payload.data
      state.isLoading = false
    },
    [getListStatistik.rejected]: (state) => {
      state.isLoading = false
    },
    [getListBar.pending]: (state) => {
      state.isLoading = true
    },
    [getListBar.fulfilled]: (state, action) => {
      // console.log(action.payload.data);
      state.dataBar = action.payload.data
      state.isLoading = false
    },
    [getListBar.rejected]: (state) => {
      state.isLoading = false
    }
  },
})

export const { openForm } = summarySlice.actions
export default summarySlice.reducer
